<!-- 上传询价单的封面 -->
<template>
    <div class="AutoParts">
        <div class="upload-show">
            <div :key="index" v-for="(item,index) in uploadUrlLocal" class="image-ctn">
                <img :src="download_url + item" alt="">
                <div class="del-btn">
                    <i class="el-icon-delete" @click="removeOriginal(index)"></i>
                </div>
            </div>
            <el-upload
                    :data="uploadData"
                    :action="url"
                    :headers="headerObj"
                    :on-success="uploadSuccess"
                    :on-remove="handleRemove"
                    list-type="picture-card"
            >
                <i slot="default" class="el-icon-plus"></i>
            </el-upload>
        </div>
        <div class="btn-ctn">
            <el-button size="small" class="search-btn" @click="cancel">取消</el-button>
            <el-button size="small" class="search-btn btn-primary" @click="save">保存</el-button>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'uploadCover',
        components: {

        },
        props:['index','uploadUrl'],
        data(){
            let userMsg = this.$util.getLocalStorage("userMsg");
            return {
                uploadUrlLocal:[],
                download_url:this.$util.QN_URL_BASE,
                imgList:[],
                uploadData:{
                    key:'AutoParts',
                    isPrivate:false,
                },
                headerObj: {
                        'access-key': userMsg.Token,
                        reqApp: 'yqgPC'
                },                     
                url:'/api/UploadFile/UploadSingle',
                dialogVisible: false,
                disabled: false
            }
        },
        mounted(){
            this.uploadUrlLocal = [...this.uploadUrl]
        },
        methods:{
            removeOriginal(index){
                this.uploadUrlLocal.splice(index,1)
            },
            cancel(){
                this.$emit('save')
            },
            save(){
                let result = [...this.uploadUrlLocal,...this.imgList]
                this.$emit('save',result,this.index)
            },
            uploadSuccess(res){
                this.imgList.push(res.fileUrl)
            },
            handleRemove(file) {
                let _url = file.response.fileUrl
                let _imgList = this.imgList
                for (let i=0;i<_imgList.length;i++){
                    if(_imgList[i] == _url){
                        _imgList.splice(i,1)
                    }
                }
            },
        }
    }
</script>
<style lang="less" scoped>
    .upload-show {
        display: flex;
        flex-wrap: wrap;
    }
    .btn-ctn {
        padding-top: 20px;
        text-align: right;
    }
    .AutoParts {
        padding: 20px;
    }
    .image-ctn {
        position: relative;
        cursor: pointer;
        width: 146px;
        height: 146px;
        border-radius: 5px;
        &:hover {
            .del-btn{
                display: block;
            }
        }
        .del-btn {
            text-align: center;
            line-height: 146px;
            font-size: @font-lg;
            color: white;
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 2;
            background: rgba(0,0,0,0.5);
        }
    }
</style>
